import React from "react";
import { TableHead, TableRow, TableCell, Tooltip } from "@material-ui/core";
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { Parser } from 'html-to-react';
import { useStyles } from "./style";

interface HeaderColumn {
  label: string;      // Column label
  className?: string; // Optional dynamic class
  tooltipText?: string; // Optional dynamic class - pass the tooltip text
}

interface TableHeaderProps {
  columns: HeaderColumn[];
}

export const TableHeader: React.FC<TableHeaderProps> = ({ columns }) => {
  const classes = useStyles();

  return (
    <TableHead>
      <TableRow>
        <TableCell className={classes.cell}></TableCell>
        {columns.map(({ label, className, tooltipText }, index) => (
          <TableCell key={index} className={`${classes.cell} ${className || ""}`}>
            {label}
            {tooltipText &&
              <Tooltip title={Parser().parse(tooltipText)} placement="bottom" arrow>
                <InfoOutlinedIcon data-testid="tooltip-svb-accounts" fontSize="small" color="action" /></Tooltip>
            }
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

